<p-listbox 
    class="w-12" 
    [options]="options" 
    [optionLabel]="optionLabel" 
    [optionDisabled]="optionDisabled"
    [dataKey]="dataKey"
    [(ngModel)]="selectedValues" 
    [checkbox]="checkbox" 
    [filter]="filter"
    [multiple]="multiple" 
    [showToggleAll]="showToggleAll" [disabled]="disabled" [listStyle]="{'height':'175px'}"
    (onChange)="onChange()">
</p-listbox>